<template>
	<div class='list-wrapper'>
		<Paginate
			:currentPage='currentPage'
			:numOfPage='numOfPage'

			v-on:incrementPage='incrementCurrentPage'
			v-on:decrementPage='decrementCurrentPage'
		/>
		<table class='list-view-table'>
			<tbody v-if='stories.length'>
				<ListItem v-for="el in paginatedList" :key="el" :id='el' />
			</tbody>
		</table>
		<Paginate
			:currentPage='currentPage'
			:numOfPage='numOfPage'

			v-on:incrementPage='incrementCurrentPage'
			v-on:decrementPage='decrementCurrentPage'
		/>
		<ScrollToTop />
	</div>
</template>

<script>
import { mapActions } from 'vuex'

import ListItem from '../components/ListItem.vue'
import ScrollToTop from '../components/ScrollToTop.vue'
import Paginate from '../components/Paginate.vue'

export default {
	name: 'ListView',
	props: ['type'],
	data: () => ({ stories: [], intervalId: undefined, currentPage: 1, pageLength: 20 }),
	components: {
		ListItem,
		Paginate,
		ScrollToTop,
	},
	created() {
		this.GET_STORIES(this.type)
			.then(() => this.setStories())
			.then(() => {
				this.intervalId = setInterval(() => {
					this.GET_NEW_STORIES(this.type).then(this.setStories)
				}, 1000 * 60 * 10)
			})
	},
	beforeDestroy() {
		clearInterval(this.intervalId)
	},
	methods: {
		...mapActions(['GET_STORIES', 'GET_NEW_STORIES']),
		incrementCurrentPage() { this.currentPage += 1 },
		decrementCurrentPage() { this.currentPage -= 1 },
		setStories() { this.stories = this.$store.getters.getStoriesByType(this.type) || [] }
	},
	computed: {
		numOfPage() {
			return Math.ceil(this.stories.length / this.pageLength)
		},
		paginatedList() {
			return this.stories.slice((this.currentPage - 1) * 20, this.currentPage * 20)
		},
	},
}
</script>

<style lang='stylus'>
.list-view-table
	width: 100%
	border-spacing: 0

</style>
